import { getConnectorConfigFile } from "api/ExecutorServiceApi";
import { getSchemaUrlFromConfigFiles } from "helpers/common";

export const fetchConnectorSchema = async (configFiles) => {
   const url = getSchemaUrlFromConfigFiles(configFiles);
   
   if (!url) throw new Error("Connector schema.json could not be located.");

   const response = await getConnectorConfigFile(url);
   const schema = response?.resultObject?.data;

   if (!response?.isSuccessful || !schema || !Array.isArray(schema.actions)) {
      throw new Error(response?.message || "Connector schema could not be loaded.");
   }

   return schema;
};

export const isConnectorSchemaCurrent = (data, version) => {
   const savedTime = Date.parse(data?.connectorVersionUpdatedDatetime);
   const versionTime = Date.parse(version?.updated_datetime);

   return !!data?.componentFiles?.schema && data.version === version?.version &&
      Number.isFinite(savedTime) && savedTime === versionTime;
};

export const cleanConnectorFlowElement = (flowElement, schema) => {
   if (!flowElement?.action || !flowElement.data) return flowElement;

   const action = schema.actions.find((item) => item.actionName === flowElement.action);

   if (!action) throw new Error(`The updated connector no longer supports action "${flowElement.action}". Select a supported action before updating this node.`);

   const fields = new Set(["errorHandling"]);

   if (action.isCredentialSupported) {
      fields.add("credential");
      fields.add("credentialRequired");
   }

   const collectFields = (items = []) => {
      items.forEach((item) => {
         if (item.field) fields.add(item.field);
         if (item.allowVariableSelection) fields.add("inputType");
         if (item.listItems) collectFields(item.listItems);
      });
   };
   collectFields(action.dataInsideAction);
   
   return {
      ...flowElement,
      data: Object.fromEntries(Object.entries(flowElement.data).filter(([field]) => fields.has(field)))
   };
};

export const applyConnectorSchema = (node, schema, configFiles, version, updatedDatetime) => ({
   ...node,
   data: {
      ...node.data,
      flowElement: cleanConnectorFlowElement(node.data.flowElement, schema),
      componentFiles: { schema },
      configFiles,
      version,
      connectorVersionUpdatedDatetime: updatedDatetime || null,
      payloadable: !!schema.payloadable
   }
});

export const getConnectorSelectedNode = (node) => ({
   ...node.data.componentFiles.schema,
   elementId: node.id,
   connectorId: node.data.componentId,
   version: node.data.version,
   data: node.data
});
